import React, { useState } from 'react';
import { loadCurrentState, saveCurrentState } from '../storage';

export type UmbilicalCordOption = 'one_minute' | 'less_than_minute' | 'not_performed' | null;

export const useUmbilicalCordStatus = () => {
  const saved = loadCurrentState();
  const option = saved?.umbilicalCord?.option ?? null;
  return { done: option !== null, option };
};

const UmbilicalCord: React.FC = () => {
  const saved = loadCurrentState();
  const [selectedOption, setSelectedOption] = useState<UmbilicalCordOption>(
    saved?.umbilicalCord?.option ?? null
  );
  const [reason, setReason] = useState<string>(
    saved?.umbilicalCord?.reason ?? ''
  );

  const handleOptionChange = (option: UmbilicalCordOption) => {
    setSelectedOption(option);
    if (option !== 'not_performed') {
      setReason('');
      saveCurrentState({ umbilicalCord: { option, reason: '' } }, 'umbilicalCord');
    } else {
      saveCurrentState({ umbilicalCord: { option, reason } }, 'umbilicalCord');
    }
  };

  const handleReasonChange = (value: string) => {
    setReason(value);
    saveCurrentState({ umbilicalCord: { option: selectedOption, reason: value } }, 'umbilicalCord');
  };

  const options: { value: UmbilicalCordOption; label: string }[] = [
    { value: 'one_minute', label: 'דקה' },
    { value: 'less_than_minute', label: 'פחות מדקה' },
    { value: 'not_performed', label: 'לא בוצע' },
  ];

  return (
    <div className="section-content-wrapper" style={{ padding: '20px', direction: 'rtl' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {options.map(({ value, label }) => (
          <label
            key={value}
            style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}
          >
            <input
              type="radio"
              name="umbilicalCord"
              value={value!}
              checked={selectedOption === value}
              onChange={() => handleOptionChange(value)}
              style={{ marginTop: '3px', cursor: 'pointer' }}
            />
            <span style={{ fontWeight: selectedOption === value ? 'bold' : 'normal' }}>
              {label}
            </span>
          </label>
        ))}
      </div>

      {selectedOption === 'not_performed' && (
        <div style={{ marginTop: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 'bold' }}>
            סיבה:
          </label>
          <textarea
            value={reason}
            onChange={(e) => handleReasonChange(e.target.value)}
            placeholder="הזן סיבה..."
            rows={3}
            style={{
              width: '100%',
              maxWidth: '400px',
              padding: '8px 10px',
              border: '1px solid #8596AF',
              borderRadius: '8px',
              fontSize: '1rem',
              direction: 'rtl',
              resize: 'vertical',
              fontFamily: 'inherit',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default UmbilicalCord;
